import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Link, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { formatISO } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellWidth100: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadRow2: {
      height: 24,
    },
    tblHeadCell2: {
      textAlign: 'center',
      verticalAlign: 'top',
      //borderBottom: 0,
    },
    tblHeadRow3: {
      height: 32,
    },
    tblCellWidth100: {
      width: 100,
    },
    appnameitem: {
      marginLeft: 8,
    },
    [theme.breakpoints.up('sm')]: {
      tblCellDateCol: {
        paddingLeft: 10,
        paddingRight: 10,
        width: 50,
      },
      tblCellAppCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 200,
        width: 250,
      }
    },
    [theme.breakpoints.up('xs')]: {
      tblCellDateCol: {

      },
      tblCellAppCol: {

      }
    },

});

class CommunicationsList extends React.Component {
  goTo(url) {
    if (url == null)
      return;
          
    this.props.history.push(`/${url}`);
   }        

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.al.nodes;
    const { isAuthenticatedAppBind } = this.props.auth;

    return (
    <div className={classes.paper}>
    <TableContainer>
      <Table>
        <TableHead className={classes.tblHead}>
          <TableRow className={classes.tblHeadRow}>
            <TableCell className={classes.tblHeadCell}>Timestamp</TableCell>
            <TableCell className={classes.tblHeadCell}>Type</TableCell>
            <TableCell className={classes.tblHeadCell}>Forwarding email</TableCell>
            <TableCell className={classes.tblHeadCell}>Destination account</TableCell>
            <TableCell className={classes.tblHeadCell}>Destination email</TableCell>
            <TableCell className={classes.tblHeadCell}>Name</TableCell>
            <TableCell className={classes.tblHeadCell}>Subject</TableCell>
            
          </TableRow>
        </TableHead>
        <TableBody>
          { thenodes.map(n => {
            //link available to admin
            let theAccountLinkUrl=null;
            if (n.destinationAccountId) {
              if (n.destinationAccountType === 1) {
                theAccountLinkUrl = "vendor?accountId=" + n.destinationAccountId;
              } else if (n.destinationAccountType === 3) {
                theAccountLinkUrl = "reseller?accountId=" + n.destinationAccountId;
              } else if (n.destinationAccountType === 4) {
                theAccountLinkUrl = "customer?accountId=" + n.destinationAccountId;
              }
            }
           
            //audit time is unzoned, need to declare it as utc.
            let atime = formatISO(new Date(n.sentTime+'Z'));

            //9: , 10: Vendor email forwarding, 100: Monthly statement';
            let commType = '';
            switch(n.commType) {
              case 0:
                commType = 'Miscellaneous';
                break;
              case 1:
                commType = 'Customer invitation';
                break;
              case 2:
                commType = 'Account invitation';
                break;
              case 3:
                commType = 'User invitation';
                break;    
              case 4:
                commType = 'Email verification';
                break;             
              case 5:
                commType = 'Subscription order';
                break;             
              case 6:
                commType = 'Subscription order view';
                break;             
              case 7:
                commType = 'Subscription order confirmation';
                break;             
              case 8:
                commType = 'Transfer assent';
                break;             
              case 9:
                commType = 'Transfer confirmation';
                break;             
              case 10:
                commType = 'Vendor email forwarding';
                break;             
              case 11:
                commType = 'Notification';
                break;             
              case 100:
                commType = 'Monthly statement';
                break;             
              default:
                commType = 'Other';
                break;                      
              }

              let name = '';
              if (n.destinationFirstname !== null) {
                name = n.destinationFirstname + ' ' + n.destinationLastname;
              }

              let accountName = n.destinationAccountName;
              if (!accountName) {
                accountName = "";
              }

            return (
              <TableRow key={n.commId} >
                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{atime}</TableCell>
                <TableCell>{commType}</TableCell>
                <TableCell>{n.forwardingEmail}</TableCell>
                {isAuthenticatedAppBind() && theAccountLinkUrl &&
                  <TableCell>
                    <Link variant="body2" onClick={() => this.goTo(theAccountLinkUrl)}>
                      {accountName}
                    </Link>
                  </TableCell>
                }
                {isAuthenticatedAppBind() && !theAccountLinkUrl &&
                  <TableCell><TableCell>{accountName}</TableCell></TableCell>
                }
                {!isAuthenticatedAppBind() &&
                  <TableCell>{accountName}</TableCell>
                }
                <TableCell>{n.destinationAddress}</TableCell>
                <TableCell>{name}</TableCell>
                <TableCell>{n.commSubject}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    );
  } // end render()
}

CommunicationsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(CommunicationsList), { al: graphql`
  fragment CommunicationsList_al on CommtEntriesConnection {
    nodes {
      commId  
      commType
      destinationAccountId
      destinationAccountType
      destinationAccountName
      destinationUserId
      destinationAddress
      destinationFirstname
      destinationLastname
      sendingAccountId 
      sendingAppId
      customerAppId
      notificationId
      forwardingEmail
      commSubject
      sentTime
    }
  }
` });
